<template>
  <div class="counterparties-user">
    <div class="counterparties-user_content" v-if="client">
      <counterparties-user-bread :name="client.company_name"/>
      <div class="counterparties-user_title">
        <h1 class="counterparties-user_title__text">{{client.company_name}}</h1>
        <counterparties-list-option-btn 
          @editItem="editClient(client.id)" 
          @archiveItem="openModal" 
          :canEdit="getPermissionsByType('can_edit_client')" 
          :canArchive="getPermissionsByType('can_archive_client') && client.id !== 41"
        />
      </div>
      <div class="counterparties-user_block" v-if="Object.keys(client).length != 0">
        <h2 class="counterparties-user_block__title svg-white-dart">
          <svg class="counterparties-user_block__title_icon" width="12" height="12" viewBox="0 0 12 12" style="transform:translateY(-1px)" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.9828 4.62409C11.9414 4.4968 11.8314 4.40404 11.699 4.38482L7.97896 3.84424L6.31525 0.473304C6.25605 0.353304 6.13382 0.277344 6.00002 0.277344C5.86619 0.277344 5.74399 0.353304 5.68476 0.473304L4.02099 3.84424L0.301004 4.38482C0.168606 4.40404 0.058567 4.4968 0.0172234 4.62407C-0.0241436 4.75136 0.0103562 4.89107 0.106192 4.98447L2.79793 7.60838L2.16259 11.3134C2.13995 11.4453 2.19418 11.5786 2.30244 11.6573C2.36368 11.7018 2.43622 11.7244 2.50911 11.7244C2.56508 11.7244 2.62124 11.7111 2.67266 11.684L6 9.93471L9.32719 11.684C9.44567 11.7463 9.58918 11.7359 9.69744 11.6573C9.80569 11.5786 9.85995 11.4453 9.83733 11.3134L9.20178 7.60838L11.8938 4.98444C11.9896 4.89107 12.0242 4.75136 11.9828 4.62409Z" fill="#2C2C2C"/></svg>
          <span class="counterparties-user_block__title_text">Counterpartie types</span>
        </h2>
        <div class="counterparties-user_block__row">
          <h3 class="counterparties-user_block__row_title">Type</h3>
          <div class="counterparties-user_block__row_descr">{{client.type.name}}</div>
        </div>
        <div class="counterparties-user_block__row" v-if="client.subtype.length">
          <h3 class="counterparties-user_block__row_title">Subtype</h3>
          <div class="counterparties-user_block__row_descr">
            <div v-for="type in client.subtype" :key="type.id">{{type.name}}</div>
          </div>
        </div>
      </div>
      <div class="counterparties-user_block" v-if="Object.keys(client).length != 0">
        <h2 class="counterparties-user_block__title svg-white-dart">
          <svg class="counterparties-user_block__title_icon" width="12" height="12" viewBox="0 0 12 12" style="transform:translateY(-1px)" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM6 5C6.55228 5 7 5.44772 7 6V9C7 9.55228 6.55228 10 6 10C5.44772 10 5 9.55228 5 9V6C5 5.44772 5.44772 5 6 5ZM6 4C6.55228 4 7 3.55228 7 3C7 2.44772 6.55228 2 6 2C5.44772 2 5 2.44772 5 3C5 3.55228 5.44772 4 6 4Z" fill="#2C2C2C"/></svg>
          <span class="counterparties-user_block__title_text">About</span>
        </h2>
        <div class="counterparties-user_block__row" v-if="client.charter_name">
          <h3 class="counterparties-user_block__row_title">Owner</h3>
          <div class="counterparties-user_block__row_descr">{{client.charter_name}}</div>
        </div>
      
        <div class="counterparties-user_block__row" v-if="client.broker.length">
          <h3 class="counterparties-user_block__row_title">Broker</h3>
          <div class="counterparties-user_block__row_descr">
            <div v-for="broker in client.broker" :key="broker.id">{{broker.name}}</div>
          </div>
        </div>
        <div class="counterparties-user_block__row" v-if="client.location">
          <h3 class="counterparties-user_block__row_title">City, Country</h3>
          <div class="counterparties-user_block__row_descr">{{client.location}}</div>
        </div>
        <div class="counterparties-user_block__row full_style " v-if="client.full_style">
          <h3 class="counterparties-user_block__row_title">Full Style</h3>
          <div class="counterparties-user_block__row_descr whitespace-spaces break-words">{{client.full_style}}</div>
          <svg ref="full_style" @click.stop="onCopy(client.full_style)" class="counterparties-user_block__row__copy" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 5.17189C0 4.13178 0.854394 3.28861 1.90834 3.28861H8.94561C9.99956 3.28861 10.854 4.13178 10.854 5.17189V12.1167C10.854 13.1568 9.99956 14 8.94561 14H1.90834C0.854394 14 0 13.1568 0 12.1167V5.17189ZM1.90834 4.60405C1.59056 4.60405 1.33294 4.85828 1.33294 5.17189V12.1167C1.33294 12.4303 1.59056 12.6846 1.90834 12.6846H8.94561C9.2634 12.6846 9.52101 12.4303 9.52101 12.1167V5.17189C9.52101 4.85828 9.2634 4.60405 8.94561 4.60405H1.90834Z" fill="#4B4B4B"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3.14605 1.88328C3.14605 0.843172 4.00044 0 5.05439 0H12.0917C13.1456 0 14 0.843172 14 1.88328V8.82811C14 9.86822 13.1456 10.7114 12.0917 10.7114C11.7236 10.7114 11.4252 10.4169 11.4252 10.0537C11.4252 9.69042 11.7236 9.39595 12.0917 9.39595C12.4094 9.39595 12.6671 9.14172 12.6671 8.82811V1.88328C12.6671 1.56967 12.4094 1.31543 12.0917 1.31543H5.05439C4.73661 1.31543 4.47899 1.56967 4.47899 1.88328C4.47899 2.24652 4.1806 2.54099 3.81252 2.54099C3.44444 2.54099 3.14605 2.24652 3.14605 1.88328Z" fill="#4B4B4B"/></svg>
        </div>
        <div class="counterparties-user_block__row" v-if="client.port && client.port.length">
          <h3 class="counterparties-user_block__row_title">Port</h3>
          <div class="counterparties-user_block__row_descr" v-for="port in client.port" :key="port.id">
            {{port.name}}{{port.country ? ', '+port.country : ''}}
          </div>
        </div>
      
        <div class="counterparties-user_block__row" v-if="client.comment">
          <h3 class="counterparties-user_block__row_title">Comment</h3>
          <div class="counterparties-user_block__row_descr"><pre>{{client.comment}}</pre></div>
        </div>
        <div class="counterparties-user_block__row" v-if="client.tags.length">
          <h3 class="counterparties-user_block__row_title">Tags</h3>
          <div class="counterparties-user_block__row_descr">
            <div class="tag-item" v-for="tag in client.tags" :key="tag.id">{{tag.name}}</div>
          </div>
        </div>
      </div>
      <div class="counterparties-user_block" v-if="Object.keys(client).length != 0 && client.contacts.length">
        <h2 class="counterparties-user_block__title svg-white-dart">
          <svg class="counterparties-user_block__title_icon" width="12" height="12" viewBox="0 0 12 12" style="transform:translateY(1px)" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.2609 0H1.73913C0.778635 0 0 0.766502 0 1.71203V7.93241C0 8.87794 0.778635 9.64444 1.73913 9.64444H2.23188V11.657C2.23188 11.9308 2.54202 12.0938 2.77313 11.9416L6.26087 9.64444H10.2609C11.2214 9.64444 12 8.87794 12 7.93241V1.71203C12 0.766502 11.2214 0 10.2609 0ZM2.26087 3.795C2.26087 3.49558 2.50744 3.25286 2.81159 3.25286H9.24638C9.55053 3.25286 9.7971 3.49558 9.7971 3.795C9.7971 4.09442 9.55053 4.33714 9.24638 4.33714H2.81159C2.50744 4.33714 2.26087 4.09442 2.26087 3.795ZM3.97101 5.42143C3.66686 5.42143 3.42029 5.66416 3.42029 5.96357C3.42029 6.26299 3.66686 6.50572 3.97101 6.50572H8.08696C8.39111 6.50572 8.63768 6.26299 8.63768 5.96357C8.63768 5.66416 8.39111 5.42143 8.08696 5.42143H3.97101Z" fill="#2C2C2C"/></svg>
          <span class="counterparties-user_block__title_text">Contact Details</span>
        </h2>
        <div class="counterparties-user_contacts-wrap" v-for="contact in client.contacts" :key="contact.id">
          <div class="counterparties-user_block__row" v-if="contact.name">
            <h3 class="counterparties-user_block__row_title">Contact Name</h3>
            <div class="counterparties-user_block__row_descr">{{contact.name}}</div>
          </div>
          <div class="counterparties-user_block__row" v-if="contact.email">
            <h3 class="counterparties-user_block__row_title">Email</h3>
            <div class="counterparties-user_block__row_descr">{{contact.email}}
              <span class="counterparties-user_contacts-invoice" v-if="contact.send_invoice" ref="sendInvoice">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.1667 11.9994C9.98083 11.9994 9.79667 11.9351 9.64583 11.8117L8.08333 10.5261L6.52 11.8117C6.21583 12.062 5.78333 12.062 5.47917 11.8117L3.91583 10.5261L2.35333 11.8117C2.1025 12.0174 1.75917 12.0586 1.47167 11.9154C1.18333 11.7723 1 11.4714 1 11.1423V2C1 0.895433 1.89543 0 3 0H9C10.1046 0 11 0.895431 11 2V11.1423C11 11.4714 10.8167 11.7723 10.5275 11.9146C10.4125 11.9711 10.2892 11.9994 10.1667 11.9994ZM7.80881 5.96291C7.86168 6.04752 7.90669 6.14716 7.9438 6.26164C7.98131 6.37629 7.99985 6.49869 8 6.62888C8 7.02729 7.85777 7.37039 7.57341 7.65817C7.28908 7.94594 6.91969 8.12369 6.46519 8.19139V8.87499C6.46519 8.91152 6.45239 8.94148 6.4267 8.96489C6.40101 8.9883 6.36813 9 6.32805 9H5.74927C5.71212 9 5.67999 8.98769 5.65282 8.96291C5.62569 8.93814 5.6121 8.90888 5.6121 8.87497V8.19137C5.42346 8.16795 5.24131 8.1276 5.06551 8.07038C4.88971 8.01307 4.74469 7.95515 4.63036 7.89658C4.51602 7.83791 4.41027 7.77549 4.31312 7.70905C4.216 7.64252 4.14954 7.59377 4.11374 7.56245C4.07804 7.53125 4.05304 7.50776 4.03873 7.49212C3.99015 7.43743 3.98725 7.38406 4.03014 7.33199L4.47171 6.80468C4.4917 6.77859 4.52458 6.76295 4.57032 6.75775C4.61314 6.75251 4.64745 6.76425 4.67319 6.79282L4.68176 6.80063C5.00471 7.05843 5.35194 7.22119 5.72348 7.28898C5.82919 7.30981 5.93502 7.32017 6.04067 7.32017C6.27213 7.32017 6.47583 7.26418 6.65157 7.15216C6.82739 7.04027 6.91527 6.88145 6.91527 6.67571C6.91527 6.60276 6.89379 6.53374 6.85089 6.46866C6.80799 6.40357 6.76013 6.34889 6.70726 6.3046C6.65435 6.26031 6.57079 6.21146 6.45651 6.15813C6.34212 6.10474 6.24784 6.06308 6.17348 6.03312C6.09918 6.00315 5.98484 5.96082 5.83053 5.90613C5.71903 5.86455 5.63116 5.83196 5.56684 5.80855C5.50253 5.78506 5.41462 5.75059 5.30316 5.70499C5.19173 5.65953 5.10243 5.61903 5.03524 5.584C4.96806 5.54887 4.88732 5.50261 4.79298 5.44528C4.6987 5.38801 4.62224 5.33265 4.56364 5.2793C4.50506 5.22594 4.44288 5.16213 4.37716 5.08792C4.31144 5.01368 4.26068 4.93818 4.22498 4.86131C4.18924 4.7845 4.15921 4.69791 4.13495 4.60152C4.11065 4.50521 4.09846 4.40365 4.09846 4.29688C4.09846 3.93747 4.23854 3.62241 4.51859 3.35156C4.79867 3.08072 5.16306 2.90623 5.61179 2.82814V2.125C5.61179 2.09114 5.62536 2.06186 5.65251 2.03711C5.67966 2.01235 5.7118 2 5.74895 2H6.32773C6.36781 2 6.40069 2.01175 6.4264 2.03515C6.45205 2.0586 6.46489 2.08856 6.46489 2.125V2.81254C6.62783 2.82815 6.78578 2.85807 6.93861 2.90239C7.09152 2.94664 7.21588 2.99028 7.31166 3.03322C7.40734 3.07619 7.49808 3.12503 7.5838 3.1797C7.66962 3.23441 7.72537 3.27216 7.75101 3.29301C7.77692 3.31387 7.79827 3.33208 7.81545 3.3477C7.86407 3.3946 7.87115 3.44409 7.83687 3.49615L7.48957 4.06648C7.46665 4.1055 7.43375 4.12636 7.3909 4.12896C7.35088 4.13675 7.3124 4.12765 7.27519 4.10161C7.26671 4.09379 7.24588 4.07818 7.21301 4.05472C7.18011 4.03129 7.12441 3.99681 7.0458 3.95122C6.96718 3.90567 6.88362 3.864 6.79494 3.82621C6.70633 3.78842 6.59986 3.75465 6.47562 3.72467C6.35138 3.69469 6.22907 3.67974 6.1091 3.67974C5.83757 3.67974 5.61605 3.73574 5.44456 3.84769C5.27308 3.95963 5.18738 4.10421 5.18738 4.28126C5.18738 4.34897 5.19954 4.41149 5.22379 4.46879C5.2481 4.52607 5.29025 4.58012 5.35028 4.63089C5.41031 4.68167 5.46674 4.72463 5.51961 4.75976C5.57249 4.7949 5.65252 4.83529 5.75966 4.88082C5.86684 4.92643 5.95327 4.96156 6.01899 4.98631C6.08479 5.01104 6.18479 5.04686 6.3191 5.0937C6.47059 5.14579 6.5864 5.18681 6.66647 5.21673C6.74642 5.2467 6.85505 5.29226 6.99214 5.35349C7.12935 5.41473 7.23726 5.47006 7.31582 5.51955C7.39443 5.56899 7.48308 5.63404 7.58163 5.7148C7.68029 5.79561 7.75597 5.87822 7.80881 5.96291Z" fill="#9AA3B0"/></svg>
              </span>
            </div>
          </div>
          <div class="counterparties-user_block__row" v-if="contact.phone">
            <h3 class="counterparties-user_block__row_title">Telephone</h3>
            <div class="counterparties-user_block__row_descr">{{contact.phone}}</div>
          </div>
          <div class="counterparties-user_block__row" v-if="contact.fax">
            <h3 class="counterparties-user_block__row_title">Fax</h3>
            <div class="counterparties-user_block__row_descr">{{contact.fax}}</div>
          </div>
        </div>
      </div>
      <div class="counterparties-user_block" v-if="Object.keys(client).length != 0">
<!--        <h2 class="counterparties-user_block__title svg-white-dart">-->
<!--          <svg class="counterparties-user_block__title_icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.81714 5.24404C7.81714 5.24404 8.42603 4.69122 7.85011 4.1153C7.27419 3.53938 6.68813 4.11501 6.68813 4.11501L5.68395 5.11927C4.6723 6.13131 4.54743 7.65226 5.55898 8.66343C6.57104 9.67547 8.12742 9.58595 9.13867 8.57399L10.8329 6.88058C12.3891 5.3244 12.3891 2.79201 10.8329 1.23584L10.7648 1.16773C9.20778 -0.389243 6.67539 -0.389243 5.11918 1.16773L1.16743 5.11898C-0.389145 6.67515 -0.389145 9.20754 1.16743 10.7645L1.23555 10.8326C2.44731 12.0441 4.26942 12.333 5.80734 11.5801C6.22019 11.3781 6.66887 10.9953 6.37271 10.4585C6.05937 9.89059 5.50893 10.0143 5.2179 10.147C4.34939 10.5048 3.06902 10.4078 2.36458 9.70372L2.29646 9.6348C1.3624 8.70155 1.3624 7.18197 2.29646 6.24793L6.24821 2.29665C7.18227 1.36259 8.70183 1.36259 9.6351 2.29665L9.704 2.36477C10.6373 3.29883 10.6373 4.8176 9.704 5.75166L8.00971 7.44507C7.62066 7.83411 7.07703 7.92366 6.68799 7.53451C6.29894 7.14536 6.42391 6.63737 6.81296 6.24822L7.81714 5.24404Z" fill="#2C2C2C"/></svg>-->
<!--          <span class="counterparties-user_block__title_text">Attachments</span>-->
<!--          <label class="counterparties-add_block_content__control_btn btn_add-file" v-if="getPermissionsByType('can_edit_client')">-->
<!--            <input type="file" multiple @change="addFiles">-->
<!--            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.3333 11.3333H12.6667V6.66662C12.6667 6.2987 12.368 6 11.9999 6C11.632 6 11.3333 6.2987 11.3333 6.66662V11.3333H6.66662C6.2987 11.3333 6 11.632 6 11.9999C6 12.368 6.2987 12.6667 6.66662 12.6667H11.3333V17.3333C11.3333 17.7013 11.632 18 11.9999 18C12.368 18 12.6667 17.7013 12.6667 17.3333V12.6667H17.3333C17.7013 12.6667 18 12.368 18 11.9999C18 11.632 17.7013 11.3333 17.3333 11.3333Z" fill="#094172"/></svg>-->
<!--            Add-->
<!--          </label>-->
<!--        </h2>-->
<!--        <div class="counterparties-add_block_attachments">-->
<!--          <div class="counterparties-add_block_attachment" v-for="(file, i) in client.files" :key="file.id">-->
<!--            <counterparties-file-option-btn :file="file" @edit-item="editFile(file, i)" @delete-item="deleteFile(file.id)" :canEdit="getPermissionsByType('can_edit_client')"/>-->
<!--            <img @click="openViewer(i)" class="counterparties-add_block_attachment-img" :src="file.thumbnail ? file.thumbnail : file.file" v-if="getAllowFile(file)">-->
<!--            <img @click="openViewer(i)" class="counterparties-add_block_attachment-img" src="../../../assets/imgNone.svg" v-else>-->
<!--            <p class="counterparties-add_block_attachment-text"-->
<!--            tabindex="0"-->
<!--            ref="fileText"-->
<!--            @blur="blurEditable($event, file)"-->
<!--            :class="{'editable': file.editable}"-->
<!--            :contenteditable="file.editable"-->
<!--            v-if="file.name">{{file.name}}</p>-->
<!--            <p class="counterparties-add_block_attachment-text" v-else>{{file.file}}</p>-->
<!--          </div>-->
<!--        </div>-->
        <payment-detail-atachements-file
          class="counterparties-user_block__files"
          :file-props="client.files ? client.files : []"
          :add-file-permission="getPermissionsByType('can_edit_client')"
          :edit-permission="getPermissionsByType('can_edit_client')"
          :delete-file-permission="getPermissionsByType('can_edit_client')"
          :visible-add-file="true"
          :await-delete-file="true"
          :class-for-title="'fz13 text-gray mt12'"
          :normal-size-button="false"
          @addFile="addFiles"
          @emitBeforeDeleteFile="deleteFile"
          @fileDeleted="refreshData"
          @changeParentId="setParentsID"
          :disabled-add-new-folder="loadAddFolder"
        ></payment-detail-atachements-file>
      </div>
    </div>


<!--    <file-viewer ref="fileViewer" v-if="client" :files="client.files" @change-name="changeFileName" @delete-file="deleteFile" :isEdit="getPermissionsByType('can_edit_client')"/>-->


    <!-- <pre>
      {{client}}
    </pre> -->

    <counterparties-modal-archive v-if="isModalOpen" @close="closeModal" @submit="archiveClient"/>
  </div>
</template>

<script>
import tippy, {hideAll} from 'tippy.js';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

import counterpartiesUserBread from "@/components/counterparties/counterpartiesUser/counterpartiesUserBread"
import counterpartiesListOptionBtn from '@/components/counterparties/counterpartiesList/counterpartiesListOptionBtn'
import counterpartiesModalArchive from '@/components/counterparties/counterpartiesList/counterpartiesModalArchive'
import PaymentDetailAtachementsFile from "@/components/paymentDetail/paymentDetailAtachementsFile";

export default {
  components: {
    PaymentDetailAtachementsFile,
    counterpartiesUserBread,
    counterpartiesListOptionBtn,
    counterpartiesModalArchive,
  },
  props: {
    client: Object
  },
  data() {
    return {
      isModalOpen: false,
      allowFormats: [".jpeg", ".png", ".raw", ".jpg", ".jfif", ".tiff", ".bmp", ".gif", "jp2", ".svg"],
      parent_id: null,
      loadAddFolder: false,
    }
  },
  computed: {
    ...mapState({
      clients: state => state.counterparties.clients
    }),
    ...mapGetters(['getPermissionsByType'])
  },
  methods: {
    ...mapActions(['axiosAddFilesToObject', 'axiosClientToArchive', 'axiosAddFilesToClient', 'axiosGetClientsById', 'axiosUpdateFile', "axiosFileDelete"]),
    ...mapMutations(['showLoad', 'hideLoad', 'addTip']),
    setParentsID(id) {
      this.parent_id = id;
    },
    editClient(id) {
      this.$router.push({name: 'Edit Counterparties', params: {id: id}})
      // this.$router.push('/counterparties/edit-counterparties/'+ id)
    },
    async archiveClient() {
      this.closeModal()
      this.showLoad()
      await this.axiosClientToArchive({ids: [this.client.id], bool: true})
      this.$router.push('/counterparties')
      this.addTip(this.client.company_name + ' is archived')
      this.hideLoad()
    },
    onCopy(text) {
      this.$copyText(text)
      setTimeout(() => {
        hideAll() // tippy.js
      }, 700)
    },
    openModal() {
      this.isModalOpen = true
    },
    closeModal() {
      this.isModalOpen = false
    },
    async addFiles(files) {
      // let newFiles = e.target.files ? e.target.files : []
      // if(this.parent_id !== null) {
      //   for(let i=0; i<files.length; i++) {
      //     if(files[i].file_type === 'FOLDER')
      //       this.loadAddFolder = true;
      //     files[i]["parent_id"] = this.parent_id;
      //   }
      // } else {
      //   for(let i=0; i<files.length; i++) {
      //     if(files[i].file_type === 'FOLDER')
      //       this.loadAddFolder = true;
      //   }
      // }
      // console.log(files)
      // await this.axiosAddFilesToClient({
      //   id: this.client.id,
      //   files: this.client.files.map(file => {
      //     return file.id
      //   }),
      //   newFiles: files
      // })
      await this.axiosAddFilesToObject({model: 'Client', model_id: this.client.id, files: files})
      this.loadAddFolder = false;
      this.client = await this.axiosGetClientsById(this.$route.params.id)
    },
    async deleteFile(id) {
      this.showLoad()
      let filesId = this.client.files.map(file => {
        return file.id
      })

      await this.axiosAddFilesToClient({
        id: this.client.id,
        files: filesId.filter(fileId => {
          return fileId != id
        }),
        newFiles: []
      })
      this.axiosFileDelete(id).then(()=> {
        this.refreshData();
        this.hideLoad()
        // this.info.files = this.info.files.filter(a=> a.id !== id);
      });
    },
    async refreshData() {
      this.client = await this.axiosGetClientsById(this.$route.params.id)
    },
    editFile(file, i) {
      file.editable = true

      this.$nextTick().then(()=>{
        this.$refs.fileText[i].focus()
      })
    },
    async blurEditable(e, file) {
      file.editable = false
      await this.axiosUpdateFile({id:file.id, name: e.target.innerText})
      //this.client = await this.axiosGetClientsById(this.$route.params.id)
    },
    getAllowFile(file) {
      let fileType = file.file.substring(file.file.lastIndexOf("."))
      if(this.allowFormats.indexOf(fileType) >= 0){
        return true
      }
      return false
    },
    async changeFileName([id, name]) {
      console.log('changeFileName', [id, name]);
      await this.axiosUpdateFile({id, name})
      this.client.files.filter(file => {
        return file.id == id
      })[0].name = name
    },
    openViewer(i) {
      this.$refs.fileViewer.showViewFileModal(i)
    }
  },
  async mounted() {
    await this.$nextTick()

    if(this.$refs.sendInvoice && this.$refs.sendInvoice.length) {
      this.$refs.sendInvoice.forEach(el => {
        tippy(el, {
          arrow: false,
          duration: [null, null],
          content: 'Send invoices to this address',
        })
      })
    }


    if(this.client.full_style){
      tippy(this.$refs.full_style, {
        arrow: false,
        duration: [null, null],
        trigger: 'click',
        content: 'Copied to clipboard',
      })
    }
  }
}
</script>

<style lang="scss">
  .counterparties-user{
    width: 280px;
    min-height: 100%;
    flex-shrink: 0;

    &_content{
      min-height: 100%;
      background-color: var(--color-bgc-page-white);
      box-shadow: inset -1px 0px 0px var(--color-border);
    }
    &_title{
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 16px 17px 16px 24px;
      &__text{
        font-weight: 500;
        font-size: 20px;
        line-height: 24px;
      }
    }
    &_block{
      position: relative;
      margin-bottom: 12px;
      &:last-of-type{
        &:after{
          display: none;
        }
      }
      &:after{
        content: '';
        position: absolute;
        bottom: 1px;
        left: 24px;
        right: 16px;
        height: 1px;
        background-color: var(--color-card-border);
      }
      &__title{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 24px 15px;
        &_icon{
          margin-right: 6px;
        }
        &_text{
          margin-right: auto;
          font-weight: 500;
          font-size: 14px;
        }
      }
      &__row{
        padding: 0 24px 14px;
        &.full_style{
          position: relative;
          padding-right: 40px;
          z-index: 1;
          &:hover{
            &:before{
              opacity: 1;
            }
          }
          &:before{
            content: '';
            position: absolute;
            top: -7px;
            left: 0;
            width: calc(100% - 1px);
            height: 100%;
            background-color: var(--color-input);
            z-index: -1;
            opacity: 0;
            transition: opacity 0.3s;
          }
        }
        &_title{
          margin-bottom: 3px;
          font-size: 13px;
          color: var(--color-gray-text);
        }
        &_descr{
          font-size: 14px;
          line-height: 20px;
        }
        &__copy{
          position: absolute;
          top: 39%;
          right: 21px;
          z-index: 2;
          cursor: pointer;
        }
        .tag-item{
          display: inline-block;
          margin-right: 6px;
          padding: 1px 5px;
          border: 1px solid var(--color-border);
          border-radius: 2px 10px 10px 2px;
          font-size: 11px;
          line-height: 13px;
        }
      }
    }
    &_contacts-wrap{
      position: relative;
      margin-bottom: 12px;
      &:after{
        content: '';
        position: absolute;
        bottom: 1px;
        left: 24px;
        right: 16px;
        height: 1px;
        background-color: var(--color-card-border);
      }
      &:last-of-type{
        &:after{
          display: none;
        }
      }
    }
    &_contacts-invoice{
      display: inline-block;
      transform: translate(3px, 2px);
    }
    .counterparties-add_block_attachments{
      padding: 0 24px 24px 24px;
    }
    .counterparties-add_block_attachment-text{
      min-width: 100%;
      min-height: 13px;
      &.editable{
        text-decoration: underline;
      }
    }
  }
</style>

<style scoped lang="scss">
  .counterparties-user_block__files {
    padding: 0 24px 14px;
  }
  .counterparties-user_content {
    height: calc(100vh - 56px);
    overflow-y: auto;
  }
  .dart-mode {
    .counterparties-user_block__row__copy {
      path {
        fill: #FFFFFF;
      }
    }
  }
</style>